import { render, staticRenderFns } from "./experienciaProfesional.vue?vue&type=template&id=1039d550"
import script from "./experienciaProfesional.vue?vue&type=script&lang=js"
export * from "./experienciaProfesional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports